@if (tabs?.length) {
  <app-tabs
    [tabs]="tabs">
  </app-tabs>
}

<br>

  <app-list-header
    name="filter"
    [canSearch]="false"
    (onCreate)="createFilter()">
  </app-list-header>

  <app-item-list
    [columns]="columns"
    [actions]="actions"
    [greenMarker]="greenMarker"
    [redMarker]="redMarker"
  [icons]="[
    { name: 'user', visible: isPatientItem },
    { name: 'exclamation-circle red', visible: isWarning, getTooltip: getWarningDetails }
    ]"
    [items$]="workItems$"
    [pageable]="false"
    (onItemClick)="view($event)">
  </app-item-list>

  @if (selectedItem) {
    <app-work-item-details
      [item]="selectedItem"
      (close)="selectedItem = null">
    </app-work-item-details>
  }

  @if (isLoading || (workItemsService.workItemsLoading$ | async)) {
    <app-loader [transparent]="true"></app-loader>
  }
